import { PaymentIcon } from 'modules/ui/atoms/Icon'

export const CCSecondaryItems = () => (
  <div className="card-icons" style={{ display: 'flex', gap: '2px' }}>
    <PaymentIcon name="visa" />
    <PaymentIcon name="amex" />
    <PaymentIcon name="discover" />
    <PaymentIcon name="mastercard" />
  </div>
)
